"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDay = getDay;
exports.convertToDay = convertToDay;
exports.getHour = getHour;
exports.getDisplayTime = getDisplayTime;
exports.isOtherDay = isOtherDay;
exports.isOtherHour = isOtherHour;
function getDay(time) {
    const date = new Date(time);
    return convertToDay(date).getTime();
}
function convertToDay(date) {
    const originalDay = date.getDate();
    const convertedDate = new Date(date);
    // Set 12 AM UTC time, since it will be the same day in most timezones
    convertedDate.setUTCHours(12, 0, 0, 0);
    if (convertedDate.getDate() !== originalDay) {
        convertedDate.setDate(originalDay);
    }
    return convertedDate;
}
function getHour(time) {
    const date = new Date(time);
    date.setMinutes(0, 0, 0);
    return date.getTime();
}
function getDisplayTime(time) {
    let options = { hour: 'numeric', minute: 'numeric' };
    if (!isToday(time)) {
        options = {
            month: 'numeric',
            day: 'numeric',
            ...options
        };
    }
    return new Date(time).toLocaleString('default', options);
}
function isOtherDay(time1, time2) {
    return getDay(time1) !== getDay(time2);
}
function isOtherHour(time1, time2) {
    return getHour(time1) !== getHour(time2);
}
function isToday(time) {
    const current = new Date();
    const target = new Date(time);
    return (current.getDate() === target.getDate() &&
        current.getMonth() === target.getMonth() &&
        current.getFullYear() === target.getFullYear());
}
//# sourceMappingURL=time.js.map